import apiClient from '../apiClient';

export const getDeliveryConfiguration = (customerId) => {
    return apiClient.get(`/customers/${customerId}/delivery-configuration`);
};

export const createDeliveryConfiguration = (customerId, data) => {
    return apiClient.post(`/customers/${customerId}/delivery-configuration`, data);
};

export const updateDeliveryConfiguration = (customerId, data) => {
    return apiClient.put(`/customers/${customerId}/delivery-configuration`, data);
};

export const deleteDeliveryConfiguration = (customerId) => {
    return apiClient.delete(`/customers/${customerId}/delivery-configuration`);
};
